/*
 * @Author: Teemo Ding
 * @Date: 2021-07-21 11:42:56
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-03-03 14:27:41
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCommunication/components/SelectCommunicationGatewayModal/index.tsx
 */
import { RadioGroup, RadioItem } from '@/src/components/Antd';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import TopContainer from '@/src/components/Antd/Modal/TopContainer';
import CheckItem from '@/src/components/CheckItem/CheckItem';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import SelectObjectAsValue from '@/src/components/SelectObjectAsValue';
import _ from 'lodash';
import React, { useMemo, useState } from 'react';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import {
  CommunicationChannelType,
  CommunicationGatewayProvider,
} from 'src/types/common/communication';
import css from './css.module.less';

interface IProps {
  handleCloseModal;
  options;
  notFoundContent;
  groupedGateways;
  onConfirm;
  defaultValue?;
  defaultCheck?;
  methodList?;
}
const SelectCommunicationGatewayModal = ({
  handleCloseModal,
  options,
  notFoundContent,
  onConfirm,
  groupedGateways,
}: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [value, setValue] = useState<any>();
  const [check, setCheck] = useState([]);
  const [radioValue, setRadioValue] = useState<string>();
  const onChange = (value) => {
    setValue(value);
    const gatewayIndex = (
      (
        groupedGateways.filter((o) => o.channelType === value.channelType)[0] ||
        {}
      ).gateways || []
    ).map((item) => item.uuid);
    if ((value || {}).channelType === CommunicationChannelType.LiveChat) {
      setRadioValue(gatewayIndex[0]);
    } else {
      setCheck(gatewayIndex);
    }
  };
  const handleSetCheck = (value) => {
    const checkCopy = _.cloneDeep(check);
    if (check.includes(value)) {
      const index = checkCopy.indexOf(value);
      checkCopy.splice(index, 1);
      setCheck(checkCopy);
    } else {
      checkCopy.push(value);
      setCheck(checkCopy);
    }
  };
  const handelSetRadioValue = ({ target: { value = '' } = {} }) => {
    setRadioValue(value);
  };
  const methodList = useMemo(
    () =>
      ((value || ({} as any)).gatewayList || []).map((item) => ({
        name: `${item.name} | ${
          item.gatewayProvider === CommunicationGatewayProvider.Zhima
            ? '芝麻客服'
            : item.gatewayProvider
        }`,
        key: item.uuid,
      })),
    [value],
  );

  return (
    <div>
      <div className={css.selectPaymentGateway}>
        <SelectObjectAsValue
          className={css.select}
          showSearch
          objectAsValue
          size='large'
          value={value}
          getPopupContainer={(trigger) => trigger}
          valueKey='channelType'
          labelKey='channelName'
          options={options || []}
          onChange={onChange}
          filterOption={(input, option) =>
            option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          notFoundContent={notFoundContent}
        />
      </div>
      {methodList && methodList.length ? (
        <Row
          elements={[
            {
              child:
                (value || {}).channelType !==
                CommunicationChannelType.LiveChat ? (
                  <CheckItem
                    title={getI18n(
                      'salesChannelCommunication.index.selectCommunicationGateway',
                    )}
                    checkList={methodList}
                    setCheck={(value) => handleSetCheck(value)}
                    check={check}
                  />
                ) : (
                  <TopContainer>
                    <ItemWrapper
                      title={getI18n(
                        'salesChannelCommunication.index.selectCommunicationGateway',
                      )}
                      containerClassName={css.checkBox}>
                      <RadioGroup
                        value={radioValue}
                        onChange={handelSetRadioValue}>
                        {methodList.map((item, index) => (
                          <RadioItem key={item.key} value={item.key}>
                            {item.name}
                          </RadioItem>
                        ))}
                      </RadioGroup>
                    </ItemWrapper>
                  </TopContainer>
                ),
            },
          ]}
        />
      ) : (
        ''
      )}
      <ModalFooter
        onOk={() => {
          onConfirm(value, check, radioValue);
        }}
        hideOkButton={
          methodList.length
            ? (value || {}).channelType === CommunicationChannelType.LiveChat
              ? !value || !radioValue
              : !value || !check.length
            : !value
        }
        onCancel={handleCloseModal}
      />
    </div>
  );
};

export default SelectCommunicationGatewayModal;
